var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu g3" }, [
    _c("ul", [
      _c("li", { staticClass: "head" }, [_vm._v("Projects")]),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: "/projects/active" } }, [
            _vm._v("Active"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: "/projects/archived" } }, [
            _vm._v("Archived"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }